import { RemoveCircleOutline } from '@mui/icons-material';
import { Button } from '@mui/material';
import ConfirmationModal from 'components/modal/ConfirmationModal';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export const deactivateAction = service => {
    return props => {
        // eslint-disable-next-line no-unused-vars
        const { component: MenuItem, onClick, params, ...restProps } = props;
        const { id, row } = params;
        const value = 'deactivate';
        const label = row?.inactive ? 'Restore' : 'Remove locally';
        let confirmationText = row?.inactive ? (
            <>Do you really want to restore?</>
        ) : (
            <>Are you sure you want to delete locally?</>
        );
        const { enqueueSnackbar } = useSnackbar();

        const [openModal, setOpenModal] = useState(false);

        const handleOpenConfirmationModal = e => {
            e.preventDefault();
            e.stopPropagation();
            setOpenModal(true);
        };

        const handleCloseConfirmationModal = () => {
            setOpenModal(false);
        };

        const handleOnClick = async () => {
            try {
                !row?.inactive
                    ? await service.removeLocally(id)
                    : await service.restore(id);
                enqueueSnackbar(
                    !row?.inactive
                        ? 'Successfully restored'
                        : 'Locally removed',
                    { variant: 'success' },
                );
            } catch (error) {
                enqueueSnackbar(
                    !row?.inactive
                        ? 'Unable remove locally'
                        : 'Unable to recover',
                    { variant: 'error' },
                );
            } finally {
                onClick(value);
                handleCloseConfirmationModal();
            }
        };
        return (
            <>
                <ConfirmationModal
                    onClose={handleCloseConfirmationModal}
                    isOpen={openModal}
                    title="Confirmation"
                    renderActions={() => (
                        <>
                            <Button
                                onClick={() => handleCloseConfirmationModal()}
                                variant="outlined"
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleOnClick}
                                color="primary"
                                variant="contained"
                            >
                                {label}
                            </Button>
                        </>
                    )}
                >
                    {confirmationText}
                </ConfirmationModal>
                <MenuItem
                    key={value}
                    value={value}
                    label={label}
                    icon={!row?.inactive ? <RemoveCircleOutline /> : null}
                    onClick={handleOpenConfirmationModal}
                    {...restProps}
                >
                    {label}
                </MenuItem>{' '}
            </>
        );
    };
};
